<template>
  <v-row no-gutters class="fill-height">
    <v-col
      v-if="$vuetify.breakpoint.lgAndUp"
      class="fill-height d-flex align-content-center flex-wrap justify-center"
      cols="12"
      sm="12"
      md="12"
      lg="6"
      xl="6"
    >
      <Logo />
    </v-col>

    <v-col
      cols="12"
      sm="12"
      md="12"
      lg="6"
      xl="6"
      style="background-color: var(--v-secondary-base)"
    >
      <div
        :class="
          $vuetify.breakpoint.lgAndUp
            ? 'd-flex align-center justify-center'
            : 'd-flex flex-column'
        "
        :style="
          $vuetify.breakpoint.lgAndUp
            ? 'height: 100%'
            : 'height: 100%; padding-bottom: 120px'
        "
      >
        <div
          v-if="$vuetify.breakpoint.mdAndDown"
          class="d-flex justify-center align-center"
          :class="$vuetify.breakpoint.smAndDown ? 'logo-mobile' : 'logo-tablet'"
        >
          <v-img
            :max-height="$vuetify.breakpoint.smAndDown ? '94' : '144'"
            :max-width="$vuetify.breakpoint.smAndDown ? '109' : '169'"
            src="@/assets/alertaDISAtivo2x.png"
          ></v-img>
        </div>
        <div class="px-4" style="width: 100%">
          <router-view></router-view>
        </div>
      </div>
      <div
        v-if="$vuetify.breakpoint.mdAndDown"
        class="px-6"
        :class="
          $vuetify.breakpoint.smAndDown
            ? 'bottom-logos-mobile'
            : 'bottom-logos-tablet'
        "
      >
        <v-divider></v-divider>
        <v-row no-gutters style="height: 100%">
          <v-col cols="6" class="d-flex align-center justify-end">
            <v-img
              :max-width="$vuetify.breakpoint.smAndDown ? '110' : '148'"
              :max-height="$vuetify.breakpoint.smAndDown ? '24' : '32'"
              src="@/assets/logo-branco-laranja.svg"
            ></v-img>
          </v-col>
          <v-col cols="6" class="pl-6 d-flex align-center">
            <v-img
              :max-width="$vuetify.breakpoint.smAndDown ? '86' : '114'"
              :max-height="$vuetify.breakpoint.smAndDown ? '24' : '32'"
              src="@/assets/logoCopel2x.png"
            ></v-img>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Logo from "@/components/auth/Logo";
export default {
  name: "Login",
  components: {
    Logo,
  },
};
</script>

<style scoped>
.bottom-logos-mobile {
  position: absolute;
  bottom: 1px;
  width: 100%;
  height: 64px;
}

.bottom-logos-tablet {
  position: absolute;
  bottom: 1px;
  width: 100%;
  height: 96px;
}

.logo-mobile {
  padding-top: 36px;
}

.logo-tablet {
  padding-top: 135px;
}
</style>
